//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapMutations } from 'vuex'
  export default {
    name:'ROSIER',
    data() {
      return {
        defaultJson:{
    "Speech Disturbance":"言语错乱",
    "Unilateral Facial Weakness":"单侧面部无力",
    "Unilateral Arm Weakness":"单侧上肢无力",
    "Visual Field Defect":"视野缺损",
    "Acute stroke very likely":"急性脑卒中非常可能",
    "Acute stroke unlikely":"急性脑卒中不考虑",
    "Any Seizures":"癫痫发作",
    "Loss of Consciousness / Syncope":"意识丧失 / 晕厥",
    "Unilateral Leg Weakness":"单侧下肢无力"
},
        form:{
          facial:'0',
          arm:'0',
          leg:'0',
          speech:'0',
          visual:'0',
          syncope:'0',
          seizure:'0',
        },
        hasScore:false,
        disabled:false,
        descTxt:'',
      }
    },
    created () {
      this.hideLoad()
    },
    methods: {
      ...mapMutations(['hideLoad']),
    },
    computed: {
      /** 计算公式结果 */
      score() {
        let self = this
        let form = JSON.parse(JSON.stringify(self.form))
        let flag = true
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (!form[key]) {
              flag = false
            } else { 
              form[key] = Number(form[key])
            }
          }
        }
        let result = form.facial + form.arm + form.leg + form.speech + form.visual + (form.syncope * -1)  + (form.seizure * -1) 
        self.hasScore = true
        if (result>0) {
          self.descTxt = '急性脑卒中非常可能'
        } else {
          self.descTxt = '急性脑卒中不考虑'
        }
        return String(result)
      }
    },
    
    
  }



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/ROSIER.vue